import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search_back.png'
import _imports_1 from '../../assets/images/ic_close.png'


const _withScopeId = n => (_pushScopeId("data-v-48be9ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "gropAvatar",
  style: { 'height': '30px', 'font-size': '18px', 'color': '#fff', 'width': '30px', 'background-color': '#9fdb5c' }
}
const _hoisted_2 = {
  key: 1,
  class: "player-nav-class"
}
const _hoisted_3 = {
  key: 2,
  class: "chatNotice"
}
const _hoisted_4 = { class: "chatNotice_title" }
const _hoisted_5 = { class: "chatNotice_content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "loading"
}
const _hoisted_8 = {
  key: 0,
  class: "time"
}
const _hoisted_9 = {
  key: 1,
  class: "systemMsg"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "msgItem"
}
const _hoisted_12 = { class: "msg" }
const _hoisted_13 = {
  key: 0,
  class: "groupname"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "left"
}
const _hoisted_23 = { class: "box_wenjian_p" }
const _hoisted_24 = { class: "right" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 8 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "refH" }, null, -1 /* HOISTED */))
const _hoisted_29 = { class: "Rname" }
const _hoisted_30 = { class: "box_posr" }
const _hoisted_31 = ["id", "src"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { key: 9 }
const _hoisted_35 = {
  key: 10,
  style: {"display":"inline-flex","align-items":"center"}
}
const _hoisted_36 = { class: "conter" }
const _hoisted_37 = ["src", "onClick"]
const _hoisted_38 = {
  key: 11,
  class: "notype"
}
const _hoisted_39 = { class: "box" }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "chat_image_overlay" }
const _hoisted_47 = { class: "box_posr" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "chat_image_overlay" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "left" }
const _hoisted_52 = { class: "box_wenjian_p" }
const _hoisted_53 = { class: "right" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "chat_image_overlay" }
const _hoisted_56 = { key: 9 }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "refH" }, null, -1 /* HOISTED */))
const _hoisted_59 = { class: "Rname" }
const _hoisted_60 = { class: "box_posr" }
const _hoisted_61 = ["id", "src"]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 3 }
const _hoisted_64 = { key: 10 }
const _hoisted_65 = {
  key: 11,
  class: "notype"
}
const _hoisted_66 = {
  key: 3,
  class: "faqQuickBar",
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_67 = {
  ref: "faqQuickScrollRef",
  class: "faqQuickScroll"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  class: "chatFooter",
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_70 = {
  key: 0,
  style: {"color":"#898989","font-size":"13px","height":"24px","text-align":"center"}
}
const _hoisted_71 = {
  key: 1,
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_72 = { class: "chatFWrap" }
const _hoisted_73 = { class: "inputBox" }
const _hoisted_74 = ["src"]
const _hoisted_75 = {
  key: 0,
  class: "Refrencebox"
}
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "bqbox" }
const _hoisted_78 = { class: "chatFooter2" }
const _hoisted_79 = { class: "inputBox" }
const _hoisted_80 = { class: "zyjuz_j chat_option" }
const _hoisted_81 = { class: "bqbox" }
const _hoisted_82 = { class: "chatFooter2" }
const _hoisted_83 = { class: "inputBox" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "bq" }
const _hoisted_86 = ["src", "onClick"]
const _hoisted_87 = ["src"]
const _hoisted_88 = ["src"]
const _hoisted_89 = ["src"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = { class: "faqSheetHeader" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pertanyaan Umum", -1 /* HOISTED */))
const _hoisted_93 = ["src"]
const _hoisted_94 = { class: "faqList" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "faqListArrow" }, null, -1 /* HOISTED */))
const _hoisted_97 = { class: "faqSheetHeader" }
const _hoisted_98 = { class: "faqHeaderActions" }
const _hoisted_99 = ["src"]
const _hoisted_100 = ["src"]
const _hoisted_101 = { class: "faqDetail" }
const _hoisted_102 = ["innerHTML"]
const _hoisted_103 = {
  key: 1,
  class: "faqEmpty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_circle = _resolveComponent("van-circle")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _directive_longpress = _resolveDirective("longpress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "chat",
      onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.options.show = false))
    }, [
      (!$setup.props.id)
        ? (_openBlock(), _createBlock(_component_van_nav_bar, {
            key: 0,
            title: $setup.checkname($setup.isGroup, $setup.name),
            "left-arrow": "",
            fixed: "",
            "safe-area-inset-top": "",
            onClickLeft: $setup.onClickLeft
          }, {
            right: _withCtx(() => [
              (!$setup.isGroup)
                ? (_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showDownApp($setup.headurl))),
                    color: "#f8f8f8",
                    round: "",
                    width: "30",
                    fit: "cover",
                    height: "30",
                    src: $setup.headurl
                  }, null, 8 /* PROPS */, ["src"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($setup.headurl), 1 /* TEXT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emits('privateGoback')))
            }),
            _createElementVNode("p", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emits('privateGoback')))
            }, _toDisplayString($setup.name), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString($setup.isGroup ? `(${$setup.groupMemberCount})` :  _ctx.$t('(在线中…)')), 1 /* TEXT */)
          ])),
      _createCommentVNode(" 群公告 "),
      ($setup.showNotice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('im.groupNotice')), 1 /* TEXT */),
              _createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onNoticeClose($setup.showNoticeGroup)))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode($setup["TextEllipsis"], {
                text: $setup.showNoticeGroup.groupnotify,
                maxLines: 3
              }, {
                default: _withCtx(({ clickToggle, expanded }) => [
                  _createElementVNode("button", {
                    onClick: clickToggle,
                    class: "noticebtn"
                  }, _toDisplayString(expanded ? _ctx.$t('im.shouqi') : _ctx.$t('im.zhangkai')), 9 /* TEXT, PROPS */, _hoisted_6)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: "msgList",
        style: _normalizeStyle({ 'margin-bottom': $setup.msgListBottomSpace })
      }, [
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_van_loading, {
                type: "spinner",
                size: "20"
              })
            ]))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "msgItemBox",
            key: item.id || item.time
          }, [
            (item.msgtype !== 12)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.IMformatDate(item.time)), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" 1000是系统消息 "),
            (item.msgtype == 10000)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.content), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (!$setup.isSelfMessage(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_van_image, {
                          fit: "cover",
                          round: "",
                          width: "40",
                          height: "40",
                          src: item.headurl
                        }, null, 8 /* PROPS */, ["src"]),
                        _createElementVNode("div", _hoisted_12, [
                          ($setup.isGroup)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createTextVNode(_toDisplayString(item.nickname) + " ", 1 /* TEXT */),
                                ($setup.checkIsAdmin(item) == 1)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $setup.adminimg
                                    }, null, 8 /* PROPS */, _hoisted_14))
                                  : _createCommentVNode("v-if", true),
                                ($setup.checkIsAdmin(item) == 2)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: $setup.zbimg
                                    }, null, 8 /* PROPS */, _hoisted_15))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (item.msgtype == 1)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "conter",
                                innerHTML: $setup.ChatUtils.createHtml(item.content)
                              }, null, 8 /* PROPS */, _hoisted_16)), [
                                [_directive_longpress, $setup.showMenu, item]
                              ])
                            : (item.msgtype == 14)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "conter",
                                  innerHTML: $setup.ChatUtils.createHtml(item.content)
                                }, null, 8 /* PROPS */, _hoisted_17)), [
                                  [_directive_longpress, $setup.showMenu, item]
                                ])
                              : (item.msgtype == 16)
                                ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                    key: 3,
                                    class: "conter",
                                    innerHTML: $setup.atemsg(item)
                                  }, null, 8 /* PROPS */, _hoisted_18)), [
                                    [_directive_longpress, $setup.showMenu, item]
                                  ])
                                : (item.msgtype == 6)
                                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                      key: 4,
                                      class: "conter",
                                      innerHTML: $setup.msgurl(item.content)
                                    }, null, 8 /* PROPS */, _hoisted_19)), [
                                      [_directive_longpress, $setup.showMenu, item]
                                    ])
                                  : (item.msgtype == 4)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                                        key: 5,
                                        onClick: ($event: any) => ($setup.onImagePreview($setup.getJsonImage(item.content))),
                                        radius: "10",
                                        style: {"margin-left":"10px"},
                                        fit: "cover",
                                        width: $setup.getJsonImageWid(item.content),
                                        src: $setup.getJsonImage(item.content)
                                      }, {
                                        loading: _withCtx(() => [
                                          _createVNode(_component_van_loading, {
                                            type: "spinner",
                                            size: "20"
                                          })
                                        ]),
                                        error: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('tips.loadFail')), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "width", "src"])), [
                                        [_directive_longpress, $setup.showMenu, item]
                                      ])
                                    : (item.msgtype == 3)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          _createCommentVNode(" autoplay loop "),
                                          _withDirectives((_openBlock(), _createElementBlock("video", {
                                            ref_for: true,
                                            ref: "videoPlayer",
                                            src: $setup.getJsonImage(item.content),
                                            id: "chat_videoElement",
                                            controls: "",
                                            muted: false
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('tips.notSuport')), 1 /* TEXT */)
                                          ], 8 /* PROPS */, _hoisted_20)), [
                                            [_directive_longpress, $setup.showMenu, item]
                                          ])
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      : (item.msgtype == 15 && item.content)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 7,
                                            class: "box_wenjian",
                                            onClick: ($event: any) => ($setup.tapFile(item.content.url, item.content.filename, item))
                                          }, [
                                            (item.content)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                  _createElementVNode("h4", null, _toDisplayString(item.content.filename || ''), 1 /* TEXT */),
                                                  _createElementVNode("p", _hoisted_23, [
                                                    _createTextVNode(_toDisplayString((item.content.size && typeof
        item.content.size == 'number' && $setup.filedatasize(item.content.size)) || ''), 1 /* TEXT */),
                                                    _createCommentVNode(" <span>{{ item.read ? '已下载' :'未下载'}} </span> ")
                                                  ])
                                                ]))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_24, [
                                              _createElementVNode("img", {
                                                src: $setup.dataimgurl(item),
                                                alt: ""
                                              }, null, 8 /* PROPS */, _hoisted_25)
                                            ]),
                                            _createCommentVNode(" <div class=\"chat_image_overlay\" v-show=\"!!item.upLoadProgress&&item.upLoadProgress!=100\">\n                                        <van-circle\n                                            v-model:current-rate=\"item.upLoadProgress\"\n                                            :rate=\"100\"\n                                            size=\"65\"\n                                            :color=\"{'0%': '#3fecff','100%': '#6149f6'}\"\n                                            :text=\"$t('tips.upload')+item.upLoadProgress\" />\n                                    </div> ")
                                          ], 8 /* PROPS */, _hoisted_21)), [
                                            [_directive_longpress, $setup.showMenu, item]
                                          ])
                                        : (item.msgtype == 21 && item.content)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                              _withDirectives(_createElementVNode("div", {
                                                class: "conter",
                                                innerHTML: $setup.ChatUtils.createHtml($setup.tryParse(item.content).content)
                                              }, null, 8 /* PROPS */, _hoisted_27), [
                                                [_directive_longpress, $setup.showMenu, item]
                                              ]),
                                              _hoisted_28,
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["conter reference", [3, 15, 4].includes($setup.tryParse(item.content).reference.msgtype) ? 'heightAuto' : ''])
                                              }, [
                                                _createElementVNode("span", _hoisted_29, _toDisplayString([3, 15, 4].includes($setup.tryParse(item.content).reference.msgtype) ?
        $setup.tryParse(item.content).reference.nickname + ' : ' : ''), 1 /* TEXT */),
                                                ($setup.tryParse(item.content).reference.msgtype == 4)
                                                  ? (_openBlock(), _createBlock(_component_van_image, {
                                                      key: 0,
                                                      class: "box_img_my",
                                                      onClick: ($event: any) => ($setup.onImagePreview($setup.getJsonImage($setup.tryParse(item.content).reference.content))),
                                                      radius: "10",
                                                      style: {"margin-left":"10px"},
                                                      fit: "cover",
                                                      height: "40",
                                                      src: $setup.getJsonImage($setup.tryParse(item.content).reference.content)
                                                    }, {
                                                      loading: _withCtx(() => [
                                                        _createVNode(_component_van_loading, {
                                                          type: "spinner",
                                                          size: "20"
                                                        })
                                                      ]),
                                                      error: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('tips.loadFail')), 1 /* TEXT */)
                                                      ]),
                                                      _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "src"]))
                                                  : ($setup.tryParse(item.content).reference.msgtype == 3)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createCommentVNode(" autoplay loop "),
                                                        _createElementVNode("div", _hoisted_30, [
                                                          _createVNode(_component_van_icon, {
                                                            name: "play-circle-o",
                                                            onClick: ($event: any) => ($setup.refplay(i))
                                                          }, null, 8 /* PROPS */, ["onClick"]),
                                                          _createElementVNode("video", {
                                                            id: 'videoPlayer1' + i,
                                                            src: $setup.getJsonImage($setup.tryParse(item.content).reference.content),
                                                            muted: false,
                                                            height: "73"
                                                          }, "controls " + _toDisplayString(_ctx.$t('tips.notSuport')), 9 /* TEXT, PROPS */, _hoisted_31)
                                                        ])
                                                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                    : ($setup.tryParse(item.content).reference.msgtype == 15 && $setup.tryParse(item.content).reference.content)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString('[' + _ctx.$t('tips.file') + ']'), 1 /* TEXT */))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($setup.tryParse(item.content).reference.nickname + ' : ') + _toDisplayString($setup.tryParse(item.content).reference.msgtype == 21 ?
            $setup.tryParse($setup.tryParse(item.content).reference.content).content :
            $setup.tryParse(item.content).reference.content), 1 /* TEXT */))
                                              ], 2 /* CLASS */)
                                            ]))
                                          : (item.msgtype == 12)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                                            : (item.msgtype == 10013)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                  _createElementVNode("div", _hoisted_36, _toDisplayString(item.content.content), 1 /* TEXT */),
                                                  _createElementVNode("img", {
                                                    src: $setup.copy_id,
                                                    class: "copyBtn",
                                                    onClick: ($event: any) => ($setup.copyclass('copyBtn', item.content.id))
                                                  }, null, 8 /* PROPS */, _hoisted_37)
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                  _createCommentVNode(" {{ msgurl(item.content) }}<br /> "),
                                                  _createTextVNode(_toDisplayString(item.msgtype + _ctx.$t('tips.forwardApp')), 1 /* TEXT */)
                                                ]))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" 自己 "),
                        _createElementVNode("div", {
                          class: _normalizeClass(["msgItem2", item.msgtype == 21 ? 'refer' : ''])
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            (item.read)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.checked_sel,
                                  class: "status",
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_40))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: $setup.checked,
                                  class: "status",
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_41)),
                            (item.msgtype == 1)
                              ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "conter2",
                                  innerHTML: $setup.ChatUtils.createHtml(item.content)
                                }, null, 8 /* PROPS */, _hoisted_42)), [
                                  [_directive_longpress, $setup.showMenu, item]
                                ])
                              : (item.msgtype == 14)
                                ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                    key: 3,
                                    class: "conter2",
                                    innerHTML: $setup.ChatUtils.createHtml(item.content)
                                  }, null, 8 /* PROPS */, _hoisted_43)), [
                                    [_directive_longpress, $setup.showMenu, item]
                                  ])
                                : (item.msgtype == 16)
                                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                      key: 4,
                                      class: "conter2",
                                      innerHTML: $setup.atemsg(item)
                                    }, null, 8 /* PROPS */, _hoisted_44)), [
                                      [_directive_longpress, $setup.showMenu, item]
                                    ])
                                  : (item.msgtype == 6)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                        key: 5,
                                        class: "conter2",
                                        innerHTML: $setup.msgurl(item.content)
                                      }, null, 8 /* PROPS */, _hoisted_45)), [
                                        [_directive_longpress, $setup.showMenu, item]
                                      ])
                                    : (item.msgtype == 4)
                                      ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                                          key: 6,
                                          class: "box_img_my",
                                          onClick: ($event: any) => ($setup.onImagePreview($setup.getJsonImage(item.content))),
                                          radius: "10",
                                          style: {"margin-left":"10px"},
                                          fit: "cover",
                                          width: "200",
                                          src: $setup.getJsonImage(item.content)
                                        }, {
                                          loading: _withCtx(() => [
                                            _createVNode(_component_van_loading, {
                                              type: "spinner",
                                              size: "20"
                                            })
                                          ]),
                                          error: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('tips.loadFail')), 1 /* TEXT */)
                                          ]),
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("div", _hoisted_46, [
                                              _createVNode(_component_van_circle, {
                                                "current-rate": item.upLoadProgress,
                                                "onUpdate:current-rate": ($event: any) => ((item.upLoadProgress) = $event),
                                                rate: 100,
                                                size: "65",
                                                color: { '0%': '#3fecff', '100%': '#6149f6' },
                                                text: _ctx.$t('tips.upload') + item.upLoadProgress
                                              }, null, 8 /* PROPS */, ["current-rate", "onUpdate:current-rate", "text"])
                                            ], 512 /* NEED_PATCH */), [
                                              [_vShow, !!item.upLoadProgress && item.upLoadProgress != 100]
                                            ])
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "src"])), [
                                          [_directive_longpress, $setup.showMenu, item]
                                        ])
                                      : (item.msgtype == 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                            _createCommentVNode(" autoplay loop "),
                                            _createElementVNode("div", _hoisted_47, [
                                              _withDirectives((_openBlock(), _createElementBlock("video", {
                                                ref_for: true,
                                                ref: "videoPlayer",
                                                src: $setup.getJsonImage(item.content),
                                                id: "chat_videoElement",
                                                muted: false,
                                                controls: ""
                                              }, [
                                                _createTextVNode(_toDisplayString(_ctx.$t('tips.notSuport')), 1 /* TEXT */)
                                              ], 8 /* PROPS */, _hoisted_48)), [
                                                [_directive_longpress, $setup.showMenu, item]
                                              ]),
                                              _withDirectives(_createElementVNode("div", _hoisted_49, [
                                                _createVNode(_component_van_circle, {
                                                  "current-rate": item.upLoadProgress,
                                                  "onUpdate:current-rate": ($event: any) => ((item.upLoadProgress) = $event),
                                                  rate: 100,
                                                  size: "65",
                                                  color: { '0%': '#3fecff', '100%': '#6149f6' },
                                                  text: _ctx.$t('tips.upload') + item.upLoadProgress
                                                }, null, 8 /* PROPS */, ["current-rate", "onUpdate:current-rate", "text"])
                                              ], 512 /* NEED_PATCH */), [
                                                [_vShow, !!item.upLoadProgress && item.upLoadProgress != 100]
                                              ])
                                            ])
                                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        : (item.msgtype == 15 && item.content)
                                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                              key: 8,
                                              class: "box_wenjian",
                                              onClick: ($event: any) => ($setup.tapFile(item.content.url, item.content.filename, item))
                                            }, [
                                              _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("h4", null, _toDisplayString(item.content.filename || ''), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_52, [
                                                  _createTextVNode(_toDisplayString((item.content.size && typeof
        item.content.size == 'number' && $setup.filedatasize(item.content.size)) || ''), 1 /* TEXT */),
                                                  _createCommentVNode(" <span>{{ item.read ? '已下载' :'未下载'}} </span> ")
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_53, [
                                                _createElementVNode("img", {
                                                  src: $setup.dataimgurl(item),
                                                  alt: ""
                                                }, null, 8 /* PROPS */, _hoisted_54)
                                              ]),
                                              _withDirectives(_createElementVNode("div", _hoisted_55, [
                                                _createVNode(_component_van_circle, {
                                                  "current-rate": item.upLoadProgress,
                                                  "onUpdate:current-rate": ($event: any) => ((item.upLoadProgress) = $event),
                                                  rate: 100,
                                                  size: "65",
                                                  color: { '0%': '#3fecff', '100%': '#6149f6' },
                                                  text: _ctx.$t('tips.upload') + item.upLoadProgress
                                                }, null, 8 /* PROPS */, ["current-rate", "onUpdate:current-rate", "text"])
                                              ], 512 /* NEED_PATCH */), [
                                                [_vShow, !!item.upLoadProgress && item.upLoadProgress != 100]
                                              ])
                                            ], 8 /* PROPS */, _hoisted_50)), [
                                              [_directive_longpress, $setup.showMenu, item]
                                            ])
                                          : (item.msgtype == 21 && $setup.tryParse(item.content).reference)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                _withDirectives(_createElementVNode("div", {
                                                  class: "conter2",
                                                  innerHTML: $setup.ChatUtils.createHtml($setup.tryParse(item.content).content)
                                                }, null, 8 /* PROPS */, _hoisted_57), [
                                                  [_directive_longpress, $setup.showMenu, item]
                                                ]),
                                                _createCommentVNode(" :style=\"tryParse(item.content).reference.msgtype == 3?{'height':'90px'}:''\" "),
                                                _hoisted_58,
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["conter2 reference", [3, 15, 4].includes($setup.tryParse(item.content).reference.msgtype) ? 'heightAuto' : ''])
                                                }, [
                                                  _createElementVNode("span", _hoisted_59, _toDisplayString([3, 15, 4].includes($setup.tryParse(item.content).reference.msgtype) ?
        $setup.tryParse(item.content).reference.nickname + ' : ' : ''), 1 /* TEXT */),
                                                  ($setup.tryParse(item.content).reference.msgtype == 4)
                                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                                        key: 0,
                                                        class: "box_img_my",
                                                        onClick: ($event: any) => ($setup.onImagePreview($setup.getJsonImage($setup.tryParse(item.content).reference.content))),
                                                        radius: "10",
                                                        style: {"margin-left":"10px"},
                                                        fit: "cover",
                                                        height: "40",
                                                        src: $setup.getJsonImage($setup.tryParse(item.content).reference.content)
                                                      }, {
                                                        loading: _withCtx(() => [
                                                          _createVNode(_component_van_loading, {
                                                            type: "spinner",
                                                            size: "20"
                                                          })
                                                        ]),
                                                        error: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$t('tips.loadFail')), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "src"]))
                                                    : ($setup.tryParse(item.content).reference.msgtype == 3)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          _createCommentVNode(" autoplay loop "),
                                                          _createElementVNode("div", _hoisted_60, [
                                                            _createVNode(_component_van_icon, {
                                                              name: "play-circle-o",
                                                              onClick: ($event: any) => ($setup.refplay(i))
                                                            }, null, 8 /* PROPS */, ["onClick"]),
                                                            _createElementVNode("video", {
                                                              id: 'videoPlayer1' + i,
                                                              src: $setup.getJsonImage($setup.tryParse(item.content).reference.content),
                                                              muted: false,
                                                              height: "73"
                                                            }, "controls " + _toDisplayString(_ctx.$t('tips.notSuport')), 9 /* TEXT, PROPS */, _hoisted_61)
                                                          ])
                                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                      : ($setup.tryParse(item.content).reference.msgtype == 15 && $setup.tryParse(item.content).reference.content)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString('[' + _ctx.$t('tips.file') + ']'), 1 /* TEXT */))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString($setup.tryParse(item.content).reference.nickname + ' : ') + _toDisplayString($setup.tryParse(item.content).reference.msgtype == 21 ?
            $setup.tryParse($setup.tryParse(item.content).reference.content).content :
            $setup.tryParse(item.content).reference.content), 1 /* TEXT */))
                                                ], 2 /* CLASS */)
                                              ]))
                                            : (item.msgtype == 12)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                  _createCommentVNode(" {{ msgurl(item.content) }}<br /> "),
                                                  _createTextVNode(_toDisplayString(item.msgtype + _ctx.$t('tips.forwardApp')), 1 /* TEXT */)
                                                ])),
                            (item.msgtype !== 12)
                              ? (_openBlock(), _createBlock(_component_van_image, {
                                  key: 12,
                                  fit: "cover",
                                  round: "",
                                  width: "40",
                                  height: "40",
                                  src: item.headurl
                                }, null, 8 /* PROPS */, ["src"]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 2 /* CLASS */)
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ]))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 4 /* STYLE */),
      ($setup.hasFaq)
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqQuickItems, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.title,
                  type: "button",
                  class: "faqQuickItem",
                  onClick: ($event: any) => ($setup.openFaqDetail(item))
                }, _toDisplayString(item.shortTitle || item.title), 9 /* TEXT, PROPS */, _hoisted_68))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */),
            _createElementVNode("button", {
              type: "button",
              class: "faqExpandBtn",
              onClick: $setup.openFaqList
            }, [
              _createVNode(_component_van_icon, { name: "arrow-up" })
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_69, [
        ($setup.isforbidchat)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString($setup.forbidtime), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_van_field, {
                    "update:model-value": $setup.debounce($setup.changeInputType),
                    modelValue: $setup.inputValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.inputValue) = $event)),
                    onKeydown: _cache[5] || (_cache[5] = (event) => $setup.keyup_submit(event)),
                    placeholder: $setup.t('play.chatText'),
                    style: {"background-color":"rgba(0, 0, 0, 0)"}
                  }, null, 8 /* PROPS */, ["update:model-value", "modelValue", "placeholder"]),
                  _createElementVNode("img", {
                    src: $setup.biaoqing,
                    class: "biaoqing",
                    onClick: $setup.openBiaoqing
                  }, null, 8 /* PROPS */, _hoisted_74)
                ]),
                ($setup.showRefrence)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createTextVNode(_toDisplayString($setup.refrenceCon.msgtype == 21 ? $setup.tryParse($setup.refrenceCon.content).content :
            $setup.refrenceCon.msgtype == 3 ? '[' + _ctx.$t('tips.video') + ']' :
                $setup.refrenceCon.msgtype == 4 ? '[' + _ctx.$t('tips.photo') + ']' :
                    $setup.refrenceCon.msgtype == 15 ? '[' + _ctx.$t('tips.file') + ']' :
                        $setup.refrenceCon.content) + " ", 1 /* TEXT */),
                      _createVNode(_component_van_icon, {
                        name: "close",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showRefrence = false, $setup.refrenceCon = {}))
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("img", {
                src: $setup.add_res,
                alt: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showAddRes = true)),
                class: "addRes_"
              }, null, 8 /* PROPS */, _hoisted_76),
              _createVNode(_component_van_button, {
                round: "",
                plain: "",
                style: {"background-color":"#00DF3A","color":"white","font-size":"12px","font-weight":"600","width":"56px","height":"33px","margin-right":"15px"},
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.sendMsg(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('发送')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
      ]),
      _createCommentVNode(" 功能选项 type=\"textarea\""),
      _createVNode(_component_van_action_sheet, {
        show: $setup.showAddRes,
        "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => (($setup.showAddRes) = $event)),
        round: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_van_field, {
                  "update:model-value": $setup.debounce($setup.changeInputType),
                  modelValue: $setup.inputValue,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.inputValue) = $event)),
                  autosize: "",
                  onKeydown: _cache[10] || (_cache[10] = (event) => $setup.keyup_submit(event)),
                  placeholder: $setup.t('play.chatText'),
                  style: {"background-color":"rgba(0, 0, 0, 0)"}
                }, null, 8 /* PROPS */, ["update:model-value", "modelValue", "placeholder"]),
                _createCommentVNode(" <img :src=\"biaoqing\" class=\"biaoqing\" @click=\"openBiaoqing\" /> ")
              ]),
              _createVNode(_component_van_button, {
                round: "",
                plain: "",
                style: {"background-color":"#00DF3A","color":"white","font-size":"12px","font-weight":"600","width":"56px","height":"33px","margin-right":"15px"},
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.sendMsg(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('发送')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createCommentVNode(" 功能选项区域 "),
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_van_uploader, {
                modelValue: $setup.fileList,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.fileList) = $event)),
                "after-read": $setup.addImg,
                "preview-image": false,
                "max-size": 7000 * 1024,
                onOversize: $setup.onOversize,
                accept: 'image/*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "photo",
                    size: "40",
                    color: "#000"
                  }),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('tips.photo')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]),
              _createVNode(_component_van_uploader, {
                modelValue: $setup.fileList,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.fileList) = $event)),
                "after-read": $setup.addVideo,
                "preview-image": false,
                "max-size": 10000 * 1024,
                onOversize: $setup.onOversize,
                accept: 'video/*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "video",
                    size: "40",
                    color: "#000"
                  }),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('tips.video')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]),
              _createVNode(_component_van_uploader, {
                modelValue: $setup.fileList,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.fileList) = $event)),
                "after-read": $setup.addFile,
                "preview-image": false,
                "max-size": 10000 * 1024,
                onOversize: $setup.onOversize,
                accept: 'file/*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "column",
                    size: "40",
                    color: "#000"
                  }),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('tips.file')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]),
              _createVNode(_component_van_uploader, {
                modelValue: $setup.fileList,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.fileList) = $event)),
                "preview-image": false,
                "max-size": 7000 * 1024,
                accept: 'image/jpeg/png',
                onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => ($setup.showDownApp($setup.headurl)), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "bill",
                    size: "40",
                    color: "#000"
                  }),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('tips.redpot')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createCommentVNode(" 弹出的表情选择 "),
      _createVNode(_component_van_action_sheet, {
        show: $setup.showShare,
        "onUpdate:show": _cache[21] || (_cache[21] = ($event: any) => (($setup.showShare) = $event)),
        round: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _createCommentVNode(" type=\"textarea\" "),
                _createVNode(_component_van_field, {
                  "update:model-value": $setup.debounce($setup.changeInputType),
                  modelValue: $setup.inputValue,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.inputValue) = $event)),
                  onKeydown: _cache[19] || (_cache[19] = (event) => $setup.keyup_submit(event)),
                  placeholder: $setup.t('play.chatText'),
                  style: {"background-color":"rgba(0, 0, 0, 0)"}
                }, null, 8 /* PROPS */, ["update:model-value", "modelValue", "placeholder"]),
                _createElementVNode("img", {
                  src: $setup.biaoqing,
                  class: "biaoqing",
                  onClick: $setup.openBiaoqing
                }, null, 8 /* PROPS */, _hoisted_84)
              ]),
              _createVNode(_component_van_button, {
                round: "",
                plain: "",
                style: {"background-color":"#00DF3A","color":"white","font-size":"12px","font-weight":"600","width":"56px","height":"33px","margin-right":"15px"},
                onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.sendMsg(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('发送')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createCommentVNode(" 表情区域 "),
            _createElementVNode("div", _hoisted_85, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bqSwpierList, (item) => {
                return (_openBlock(), _createElementBlock("img", {
                  src: item.img,
                  key: item.name,
                  class: "bqitem",
                  onClick: ($event: any) => ($setup.selBq(item.name))
                }, null, 8 /* PROPS */, _hoisted_86))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"])
    ]),
    _createVNode(_component_van_overlay, {
      show: $setup.downloadshow,
      onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.downloadshow = false)),
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("img", {
            class: "bg",
            src: $setup.arterBg,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_87),
          _createElementVNode("img", {
            class: "btn",
            src: $setup.arterBtn,
            onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.open())),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_88),
          _createElementVNode("img", {
            class: "offbtn",
            src: $setup.offArterBtn,
            alt: "",
            onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.downloadshow = false))
          }, null, 8 /* PROPS */, _hoisted_89)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    ($setup.options.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ top: $setup.options.top + 'px', left: $setup.options.left + 'px' }),
          class: "options"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options.items, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "option",
              onClick: ($event: any) => ($setup.optionTap(option))
            }, _toDisplayString(option), 9 /* TEXT, PROPS */, _hoisted_90))
          }), 128 /* KEYED_FRAGMENT */))
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    ($setup.showFaqPanel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "faqOverlay",
          onClick: $setup.closeFaqPanel
        }, [
          _createElementVNode("div", {
            class: "faqSheet",
            onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
          }, [
            ($setup.faqView === 'list')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("button", {
                      type: "button",
                      class: "faqIconBtn",
                      onClick: $setup.closeFaqPanel
                    }, [
                      _createElementVNode("img", {
                        src: $setup.faqClose,
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_93)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqItems, (item) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: item.title,
                        type: "button",
                        class: "faqListItem",
                        onClick: ($event: any) => ($setup.openFaqDetail(item))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
                        _hoisted_96
                      ], 8 /* PROPS */, _hoisted_95))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("h3", null, _toDisplayString($setup.activeFaq && $setup.activeFaq.title), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "faqIconBtn",
                        onClick: $setup.openFaqList
                      }, [
                        _createElementVNode("img", {
                          src: $setup.faqBack,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_99)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "faqIconBtn",
                        onClick: $setup.closeFaqPanel
                      }, [
                        _createElementVNode("img", {
                          src: $setup.faqClose,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_100)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    ($setup.getFaqHtml($setup.activeFaq))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: $setup.getFaqHtml($setup.activeFaq)
                        }, null, 8 /* PROPS */, _hoisted_102))
                      : (_openBlock(), _createElementBlock("div", _hoisted_103, " Belum ada detail "))
                  ])
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}